import { SceneObject } from '@cgs/wge';

export const LOADING_SCREEN_TOKEN = Symbol('LOADING_SCREEN_TOKEN');

export interface ILoadingScreen {
  render(rootScene: SceneObject): Promise<void>;
  step(): void;
  addSteps(steps: number): void;
  finish(): Promise<void>;
  deinitialize(): void;
}
